export default __webpack_public_path__ + "static/media/yandex.03123fbc.svg";